import { get, post } from '../../utils/http';

export const fetchAccountsOrganizationalPositions = ({ accountId }) =>
  get(`/accounts/${accountId}/organizations-positions`);

export const bulkUpdateAccountsPositionRates = ({ accountId, data }) =>
  post(`/accounts/${accountId}/organizations-positions/bulk-update-rates`, data);
